import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import CmsfLogo from '../../../reports/ClaimReport/cmsf_logo_update.jpg';
import { settlementClaimsService } from "../../../services/settlementClaims.service";

const numberFormat = (value) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);

const numberToWords = (num) => {
  if (num === null || num === undefined) return "Zero";

  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen",
  ];

  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const convert = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convert(n % 100) : "");
    if (n < 100000)
      return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
    if (n < 10000000)
      return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
    if (n < 1000000000)
      return (
        convert(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + convert(n % 10000000) : "")
      );
    return n;
  };

  // Split taka and paisa
  const parts = num.toString().split(".");
  const taka = parseInt(parts[0], 10);
  const paisa = parts[1] ? parseInt(parts[1].padEnd(2, "0").slice(0, 2), 10) : 0;

  let words = "";
  if (taka > 0) words += `${convert(taka)} Taka`;
  if (paisa > 0) {
    if (words) words += " and ";
    words += `${convert(paisa)} Paisa`;
  }
  if (!words) return "Zero";
  return words;
};

const toTitleCaseKeepAcronyms = (str) => {
  const acronyms = ["PLC", "LTD", "AB"];
  if (!str) return "-";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => acronyms.includes(word.toUpperCase()) ? word.toUpperCase() :
      word.split("-").map(part => part.charAt(0).toUpperCase() + part.slice(1)).join("-")
    )
    .join(" ");
};

const formatLongDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

// ======================================================

const SettlementWorkflowPDF = ({ open, onClose, searchParams, settlementNo }) => {
  const [loading, setLoading] = useState(false);
  const [copyMessage, setCopyMessage] = useState("");
  const [SettlementData, setSettlementData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const user = JSON.parse(localStorage.getItem("user-name"));
  const userName = user?.fullName;
  const [totalAmount, setTotalAmount] = useState(0);
  
  const page_no = 1;
  const page_limit = 500;
  // Refs for print and copy
  const printRef = useRef();
  const copyRef = useRef();

  useEffect(() => {
    if (!open) return;

    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await settlementClaimsService.getClaims({
          page_no: page_no,
          page_limit: page_limit,
          dividend_type: searchParams.dividendType,
          claim_status: searchParams.claimStatus,
          filter_type: searchParams.searchBy,
          filter_value: searchParams.searchKeyword,
          settlement_no: settlementNo,
          settlement_part: searchParams.settlementPart,
        });
        if (res.data?.success && res.data.payload.data !== null) {
          setSettlementData(res.data.payload.data);
          setTotalCount(res.data.payload.pagination.total_count);
          const totalamountCount = res.data.payload.data.reduce((sum, item) => sum + Number(item.totalAmount || 0), 0);
          setTotalAmount(totalamountCount);
        } else {
          Swal.fire({
            customClass: { container: 'my-swal' },
            icon: 'error',
            title: 'Could not load data',
            text: " " + ("Please Try Again!" || "Unknown error"),
            showConfirmButton: true,
          }).then((res) =>{
            if(res.isConfirmed){
              onClose();
            }
          }
          )
        }
      } catch (err) {
        Swal.fire({
          customClass: { container: 'my-swal' },
          icon: 'error',
          title: 'Failed to load settlement workflow data',
          text: " " + (err.message || "Unknown error"),
          showConfirmButton: true,
          timer: 3000
        });
      }

      setLoading(false);
    };

    fetchData();
  }, [open]);

  // =================== Download PDF ======================
  // const handleDownload = () => {
  //   const doc = new jsPDF("p", "mm", "a4");

  //   const clone = printRef.current.cloneNode(true);
  //   clone.style.fontSize = "13pt";
  //   clone.style.color = "black";
  //   clone.style.backgroundColor = "white";

  //   // Add print-specific styles
  //   const style = document.createElement('style');
  //   style.textContent = `
  //     @media print {
  //       body { margin: 0; padding: 0; }
  //       .page-break { page-break-before: always; }
  //     }
  //   `;
  //   clone.appendChild(style);

  //   doc.html(clone, {
  //     callback: () => doc.save(`SettlementWorkflowData.pdf`),
  //     margin: [10, 10, 10, 10],
  //     autoPaging: "text",
  //     x: 10,
  //     y: 10,
  //     width: 180,
  //     windowWidth: 1000,
  //   });
  // };
  const handleDownload = () => {
  const doc = new jsPDF("p", "mm", "a4");

  const PAGE_WIDTH = doc.internal.pageSize.getWidth();
  const LEFT = 10;

  // Draw full header every page
  const drawPageHeader = () => {
    let y = 10;

    // Logo
    doc.addImage(CmsfLogo, "PNG", (PAGE_WIDTH - 80) / 2, y, 80, 20);
    y += 25;

    // Address
    doc.setFontSize(10);
    doc.text(
      "DCCI Building (Level-3), 65-66 Motijheel C/A, Dhaka-1000",
      PAGE_WIDTH / 2,
      y,
      { align: "center" }
    );
    y += 5;

    doc.text("Tel: +880241052430, Email: claim@cmsfbd.org", PAGE_WIDTH / 2, y, {
      align: "center",
    });
    y += 10;

    // Report Info Left
    doc.setFontSize(9);
    doc.text(`Total Claims (${searchParams.claimStatus}): ${totalCount}`, LEFT, y);
    y += 5;
    doc.text(`Dividend Type: ${searchParams.dividendType}`, LEFT, y);
    y += 5;
    doc.text(`Claim Status: ${searchParams.claimStatus}`, LEFT, y);
    y += 5;
    doc.text(`Searched By: ${searchParams.searchBy}`, LEFT, y);
    y += 5;
    doc.text(`Settlement No: ${settlementNo}`, LEFT, y);

    // Right Side
    let rightY = 22 + 25;
    doc.text(`Date: ${formatLongDate(Date.now())}`, PAGE_WIDTH - 60, rightY);
    rightY += 5;
    doc.text(`Generated By: ${userName}`, PAGE_WIDTH - 60, rightY);

    // Line below header
    y += 8;
    doc.line(LEFT, y, PAGE_WIDTH - LEFT, y);

    return y + 5;
  };

  let headerBottomY = 80; // fallback
  const firstPageHeaderY = drawPageHeader(); 

  autoTable(doc, {
    head: [[
      "SL", "Name", "BO ID", "Folio ID", "Settlement No",
      "Settlement Part", "Issuer Name", "Amount (BDT)", "Status"
    ]],

    body: SettlementData.map((item, idx) => [
      idx + 1,
      item.name,
      item.bo_id,
      item.folio_number,
      item.settlementNo,
      item.settlementPart,
      item.issuer_name,
      numberFormat(item.totalAmount),
      item.claimStatus
    ]),

    startY: firstPageHeaderY,


  didDrawPage: (data) => {
    const pageNumber = doc.internal.getNumberOfPages();

    if (pageNumber === 1) {
      // first page already has full header
      return;
    }

    // other pages get only table header (autoTable does this automatically)
  },

    theme: "grid",
    // 🔥 GLOBAL STYLES (strong borders + dark text)
  styles: {
    fontSize: 8,
    textColor: [30, 30, 30],
    lineColor: [40, 40, 40],     // deep border
    lineWidth: 0.4,               // thicker border
    textAlign:"center"
  },

  // 🔥 HEADER STYLE (background + bold + border)
  headStyles: {
    fillColor: [200, 200, 200],  // grey background
    textColor: [0, 0, 0],        // black text
    fontStyle: "bold",
    lineWidth: 0.6,
    
  },

  // 🔥 BODY ROWS (optional tweaks)
  bodyStyles: {
    lineColor: [70, 70, 70],     // darker row borders
    textColor: [30, 30, 30]
  },
  });

  // TOTAL ROW
  autoTable(doc, {
    body: [
      ["Total Amount (In BDT)", numberFormat(totalAmount)]
    ],
    startY: doc.lastAutoTable.finalY + 5,
    theme: "grid",
    styles: {
    fontSize: 10,
    halign: "center",
    textColor: [50, 50, 50],      
    lineColor: [50, 50, 50],       // border color
    lineWidth: 0.5
  },

  bodyStyles: {
    fillColor: [245, 245, 245],    // light background
  }
  });

  doc.save("SettlementWorkflowData.pdf");
};


  // // =================== Direct Print Function ======================
  // const handleDirectPrint = () => {
  //   const printWindow = window.open('', '_blank');
    
  //   const printContent = `
  //     <!DOCTYPE html>
  //     <html>
  //     <head>
  //       <title>Settlement Workflow Report</title>
  //       <style>
  //         /* A4 Page Size */
  //         @page {
  //           size: A4;
  //           margin: 15mm;
  //         }
          
  //         @media print {
  //           body {
  //             margin: 0;
  //             padding: 0;
  //             font-family: 'Times New Roman', serif;
  //             font-size: 12pt;
  //             line-height: 1.4;
  //             width: 210mm;
  //             height: 297mm;
  //           }
            
  //           .page-container {
  //             width: 230mm;
  //             margin: 0 auto;
  //             padding: 10mm 0;
  //             box-sizing: border-box;
  //           }
            
  //           /* Page breaks */
  //           .page-break {
  //             page-break-before: always;
  //             page-break-inside: avoid;
  //           }
            
  //           /* Table header repeat */
  //           table {
  //             width: 100%;
  //             border-collapse: collapse;
  //             page-break-inside: auto;
  //           }
            
  //           thead {
  //             display: table-header-group;
  //           }
            
  //           tbody {
  //             display: table-row-group;
  //           }
            
  //           tr {
  //             page-break-inside: avoid;
  //             page-break-after: auto;
  //           }
            
  //           /* Table styling */
  //           th, td {
  //             border: 1px solid #000;
  //             padding: 4px 6px;
  //             text-align: center;
  //             font-size: 10pt;
  //           }
            
  //           th {
  //             background-color: #f2f2f2;
  //             font-weight: bold;
  //           }
            
  //           /* Prevent image overflow */
  //           img {
  //             max-width: 100%;
  //             height: auto;
  //           }
            
  //           /* Header/footer */
  //           .report-header, .report-footer {
  //             page-break-inside: avoid;
  //           }
            
  //           /* Page numbers */
  //           .page-number:after {
  //             content: "Page " counter(page);
  //             position: absolute;
  //             bottom: 10mm;
  //             right: 20mm;
  //             font-size: 10pt;
  //           }
  //         }
          
  //         /* Screen styles */
  //         @media screen {
  //           body {
  //             font-family: 'Times New Roman', serif;
  //             font-size: 12pt;
  //             line-height: 1.4;
  //             background-color: white;
  //             color: black;
  //             width: 210mm;
  //             min-height: 297mm;
  //             margin: 0 auto;
  //             padding: 20mm;
  //             box-shadow: 0 0 10px rgba(0,0,0,0.1);
  //           }
            
  //           .page-container {
  //             width: 100%;
  //           }
            
  //           table {
  //             width: 100%;
  //             border-collapse: collapse;
  //             margin: 10px 0;
  //           }
            
  //           th, td {
  //             border: 1px solid #000;
  //             padding: 4px 6px;
  //             text-align: center;
  //             font-size: 10pt;
  //           }
            
  //           th {
  //             background-color: #f2f2f2;
  //             font-weight: bold;
  //           }
            
  //           .print-only {
  //             display: none;
  //           }
            
  //           .no-print {
  //             display: block;
  //           }
  //         }
          
  //         /* Common styles */
  //         .header-section {
  //           text-align: center;
  //           margin-bottom: 20px;
  //           page-break-inside: avoid;
  //         }
          
  //         .logo {
  //           width: 80mm;
  //           margin: 0 auto 10px;
  //         }
          
  //         .report-info {
  //           display: flex;
  //           justify-content: space-between;
  //           margin-bottom: 15px;
  //           page-break-inside: avoid;
  //         }
          
  //         .info-left, .info-right {
  //           flex: 1;
  //         }
          
  //         .info-row {
  //           display: flex;
  //           margin-bottom: 5px;
  //         }
          
  //         .info-label {
  //           min-width: 120px;
  //           font-weight: bold;
  //         }
          
  //         .total-row {
  //           font-weight: bold;
  //           background-color: #f8f8f8;
  //         }
          
  //         .footer-note {
  //           text-align: center;
  //           margin-top: 20px;
  //           font-style: italic;
  //           page-break-inside: avoid;
  //         }
  //       </style>
  //     </head>
  //     <body>
  //       <div class="page-container">
  //         <!-- Header Section -->
  //         <div class="header-section">
  //           <img src="${CmsfLogo}" alt="CMSF Logo" class="logo" />
  //           <div style="font-size: 11pt; line-height: 1.5;">
  //             DCCI Building (Level-3), 65-66 Motijheel C/A, Dhaka-1000<br />
  //             Tel: +880241052430, Email: claim@cmsfbd.org
  //           </div>
  //         </div>
          
  //         <!-- Report Info -->
  //         <div class="report-info">
  //           <div class="info-left">
  //             <div class="info-row">
  //               <span class="info-label">Total Claims:</span>
  //               <span>${totalCount} (${searchParams.claimStatus || 'All'})</span>
  //             </div>
  //             <div class="info-row">
  //               <span class="info-label">Dividend Type:</span>
  //               <span>${searchParams.dividendType || 'N/A'}</span>
  //             </div>
  //             <div class="info-row">
  //               <span class="info-label">Claim Status:</span>
  //               <span>${searchParams.claimStatus || 'N/A'}</span>
  //             </div>
  //             <div class="info-row">
  //               <span class="info-label">Searched By:</span>
  //               <span>${searchParams.searchBy || 'N/A'}</span>
  //             </div>
  //             <div class="info-row">
  //               <span class="info-label">Settlement No:</span>
  //               <span>${settlementNo || 'N/A'}</span>
  //             </div>
  //           </div>
            
  //           <div class="info-right">
  //             <div class="info-row">
  //               <span class="info-label">Date:</span>
  //               <span>${formatLongDate(Date.now())}</span>
  //             </div>
  //             <div class="info-row">
  //               <span class="info-label">Generated by:</span>
  //               <span>${userName}</span>
  //             </div>
  //             <div class="info-row">
  //               <span class="info-label">Generated on: </span>
  //               <span>${new Date().toLocaleString()}</span>
  //             </div>
  //           </div>
  //         </div>
          
  //         <!-- Table Section -->
  //         <table>
  //           <thead>
  //             <tr>
  //               <th>SL</th>
  //               <th>Name</th>
  //               <th>BO ID</th>
  //               <th>Folio ID</th>
  //               <th>Settlement No</th>
  //               <th>Settlement Part</th>
  //               <th>Issuer Name</th>
  //               <th>Amount (BDT)</th>
  //               <th>Status</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             ${SettlementData.map((item, idx) => `
  //               <tr>
  //                 <td>${idx + 1}</td>
  //                 <td>${item.name}</td>
  //                 <td>${item.bo_id}</td>
  //                 <td>${item.folio_number}</td>
  //                 <td>${item.settlementNo}</td>
  //                 <td>${item.settlementPart}</td>
  //                 <td>${item.issuer_name}</td>
  //                 <td>${numberFormat(item.totalAmount)}</td>
  //                 <td>${item.claimStatus}</td>
  //               </tr>
  //             `).join('')}
              
  //             <!-- Total Row -->
  //             <tr class="total-row">
  //               <td colspan="7" style="text-align: center;">Total</td>
  //               <td>${numberFormat(totalAmount)}</td>
  //               <td></td>
  //             </tr>
  //           </tbody>
  //         </table>
  //       </div>
        
  //       <script>
  //         // Auto-print and close
  //         window.onload = function() {
  //           setTimeout(function() {
  //             window.print();
  //             setTimeout(function() {
  //               window.close();
  //             }, 500);
  //           }, 500);
  //         };
  //       </script>
  //     </body>
  //     </html>
  //   `;
    
  //   printWindow.document.write(printContent);
  //   printWindow.document.close();
  // };

  const handleCopy = async () => {
    try {
      const html = copyRef.current.outerHTML;

      await navigator.clipboard.write([
        new window.ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([copyRef.current.innerText], { type: "text/plain" })
        })
      ]);

      // Show temporary message
      setCopyMessage("Copied to clipboard!");
      setTimeout(() => setCopyMessage(""), 3000);
    } catch (err) {
      console.error("Copy failed", err);
      setCopyMessage("Failed to copy!");
      setTimeout(() => setCopyMessage(""), 3000);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Settlement Workflow</DialogTitle>

      <DialogContent>
        {loading ? (
          <div style={{ textAlign: "center", padding: "10px" }}>
            <CircularProgress />
          </div>
        ) : (
          <div ref={printRef} style={{ padding: "10px 10px 10px 10px", fontFamily: "Times New Roman" }}>
            {/* Add print-specific styles */}
            <style>
              {`
                @media print {
                  body { margin: 0; padding: 0; }
                  .print-page {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 20mm;
                    page-break-after: always;
                  }
                  table { page-break-inside: auto; }
                  tr { page-break-inside: avoid; }
                  thead { display: table-header-group; }
                }
              `}
            </style>

            {/* Header Section */}
            <div style={{ textAlign: "center", marginBottom: "30px" }}>
              <img
                src={CmsfLogo}
                alt="CMSF Logo"
                style={{ width: "320px", marginBottom: "0px" }}
              />
              <div style={{ fontSize: "17px", lineHeight: "1.7" }}>
                DCCI Building (Level-3), 65-66 Motijheel C/A, Dhaka-1000<br />
                Tel: +880241052430, Email: claim@cmsfbd.org
              </div>
            </div>

            {/* Report Info */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ fontFamily: 'Times New Roman, serif', lineHeight: '1.8', marginBottom: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <span>Total Claims ({searchParams.claimStatus || 'All'}):</span>
                  <span style={{ marginLeft: '10px', color: '#2c3e50' }}>{totalCount}</span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr ', gap: '8px' }}>
                  <div style={{ display: 'flex' }}>
                    <span style={{ minWidth: '120px' }}>Dividend Type:</span>
                    <span>{searchParams.dividendType || 'N/A'}</span>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <span style={{ minWidth: '120px' }}>Claim Status:</span>
                    <span>{searchParams.claimStatus || 'N/A'}</span>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <span style={{ minWidth: '120px' }}>Searched By:</span>
                    <span>{searchParams.searchBy || 'N/A'}</span>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <span style={{ minWidth: '120px' }}>Settlement No:</span>
                    <span>{settlementNo || 'N/A'}</span>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                <div>
                  <div style={{ display: 'flex', marginBottom: '5px' }}>
                    <span style={{ minWidth: '140px' }}>Date:</span>
                    <span style={{ marginLeft: '10px' }}>{formatLongDate(Date.now())}</span>
                  </div>
                  <div style={{ display: 'flex' }}>
                    <span style={{ minWidth: '140px' }}>Generated by:</span>
                    <span style={{ marginLeft: '10px' }}>{userName}</span>
                  </div>
                </div>
              </div>
            </div>

            <br />

            <div ref={copyRef}>
              {/* Table Section */}
              <table width="100%" style={{ marginTop: "10px", border: "1px solid black",}}>
                <thead>
                  <tr style={{ backgroundColor: "#f2f2f2", textAlign: "center" }}>
                    <th style={{ border: "1px solid black", padding: "5px" }}>SL</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Name</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>BO ID</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Folio ID</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Settlement No</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Settlement Part</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Issuer Name</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Amount (BDT)</th>
                    <th style={{ border: "1px solid black", padding: "5px" }}>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {SettlementData?.map((item, idx) => (
                    <tr key={item.id} style={{ textAlign: "center" }}>
                      <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>{idx + 1}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.name}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.bo_id}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.folio_number}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.settlementNo}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.settlementPart}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.issuer_name}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{numberFormat(item.totalAmount)}</td>
                      <td style={{ border: "1px solid black", padding: "5px" }}>{item.claimStatus}</td>
                    </tr>
                  ))}
                  {/* Total Row */}
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", border: "1px solid black", padding: "5px" }}>
                      <strong>Total</strong>
                    </td>
                    <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}>
                      <strong>{numberFormat(totalAmount)}</strong>
                    </td>
                    <td style={{ border: "1px solid black", padding: "5px", textAlign: "center" }}></td>
                  </tr>
                </tbody>
              </table>

              <br />
              <p>Thank you for your co-operation.</p>
            </div>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        {/* <div style={{ display: "flex", alignItems: "center" }}>
          {copyMessage && (
            <span style={{ marginRight: "10px", color: "green", fontWeight: "bold" }}>
              {copyMessage}
            </span>
          )}
          <Button variant="contained" color="primary" onClick={handleDirectPrint}>
            Print PDF
          </Button>
        </div> */}

        <Button onClick={handleDownload} color="primary" variant="contained">
          Download PDF
        </Button>

        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettlementWorkflowPDF;